module.exports = __webpack_public_path__ + "img/xp1_003.dca90136.jpg";